// import React from 'react';

// import { PilotItem, pilotList } from 'modules/fpv-one-pilot';

// export const Pilots: React.FC = () => {
//   return (
//     <section className="page">
//       <div className="pilots">
//         <header className="pilots__header">
//           <p className="pilots__label t-upper t-zeta">ORQA Pilots</p>
//           <h1 className="t-huge t-center t-upper s-bottom--lrg">
//             Meet Our Sponsored Aces
//           </h1>
//           <p className="pilots__description t-delta t-center">
//             Dive into the world of FPV excellence and discover the incredible
//             talents who trust our goggles to conquer the skies.
//           </p>
//         </header>
//         <div className="pilots__list">
//           {pilotList.map(pilot => (
//             <PilotItem key={pilot.handle} pilot={pilot} />
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

export const Pilots = () => {
  const history = useHistory();
  const [counter, setCounter] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCounter(prevCounter => prevCounter - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (counter === 0) {
      history.replace('/');
    }
  }, [counter, history]);

  return (
    <>
      <section
        className="page"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          minHeight: '50vh',
        }}
      >
        <div
          className="wrapper wrapper--narrow"
          style={{ textAlign: 'center' }}
        >
          <h1 className="t-beta s-bottom--sml">Redirecting to Homepage</h1>
          <p className="t-zeta s-bottom--sml" style={{ marginBottom: '1rem' }}>
            This page is obsolete and is no longer part of our active website.
            You will be automatically redirected to the Homepage in...
          </p>
          <div
            style={{
              fontSize: '4rem',
              fontWeight: 'bold',
              marginBottom: '1rem',
              minWidth: '60px',
            }}
          >
            {counter}
          </div>
          <p className="t-zeta">
            If you are not redirected, please click{' '}
            <a href="/">Homepage link</a>.
          </p>
        </div>
      </section>
    </>
  );
};
